import { membershipNameType } from './constant'

export const CNY_PROMO = {
  couponCode: 'CNY2026',
  startDate: new Date('2026-01-29T00:00:00Z'), // CNY day
  endDate: new Date('2026-03-01T04:00:00Z'), // March 1st 12pm HKT
  proMonthlyPrice: 50, // regular monthly price
  proMonthlyAnnualized: 600, // $50 × 12
  proYearlyPromoPrice: 360,
  proMonthlyEquivalent: 30, // $360 / 12
  discountPercent: 40, // vs monthly pricing
}

export function isCNYPromoActive(): boolean {
  const now = new Date()
  return now >= CNY_PROMO.startDate && now <= CNY_PROMO.endDate
}

export function getCNYPromoEndDate(): Date {
  return CNY_PROMO.endDate
}

export function isUserEligibleForCNYPromo(membershipName: string): boolean {
  if (!isCNYPromoActive()) return false
  if (!membershipName) return false
  return (
    membershipName !== membershipNameType.Standard &&
    membershipName !== membershipNameType.Pro &&
    membershipName !== membershipNameType.Teacher
  )
}
